import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';

export async function addPlanUserInvite(planId: string, userId: string) {
  await db.setDoc(db.doc(firestore, 'plans', planId, 'userInvites', userId), {
    createdAt: db.serverTimestamp(),
  });
}

export async function addPlanContactInvite(planId: string, contactId: string, phoneNumber: string) {
  await db.addDoc(db.collection(firestore, 'plans', planId, 'contactInvites'), {
    createdAt: db.serverTimestamp(),
    contactId,
    phoneNumber,
  });
}

export async function deletePlanUserInvite(planId: string, userId: string) {
  await db.deleteDoc(db.doc(firestore, 'plans', planId, 'userInvites', userId));
}

export async function deletePlanContactInvite(planId: string, contactId: string) {
  const q = db.query(
    db.collection(firestore, 'plans', planId, 'contactInvites'),
    db.where('contactId', '==', contactId)
  );
  const snapshot = await db.getDocs(q);
  await Promise.all(
    snapshot.docs.map((doc) =>
      db.deleteDoc(db.doc(firestore, 'plans', planId, 'contactInvites', doc.id))
    )
  );
}

export async function getPlanUserInviteIds(planId: string) {
  const q = db.query(db.collection(firestore, 'plans', planId, 'userInvites'));
  const snapshot = await db.getDocs(q);
  return snapshot.docs.map((doc) => doc.id);
}

export async function getPlanContactInviteIds(planId: string) {
  const q = db.query(db.collection(firestore, 'plans', planId, 'contactInvites'));
  const snapshot = await db.getDocs(q);
  return snapshot.docs.map((doc) => doc.data().contactId);
}
